import React from 'react';
import { ConfigProvider, theme } from 'antd'
import RouteF from './RouteF';
import { BrowserRouter } from 'react-router-dom'
import { store } from "./shared";
import { Provider } from "react-redux"

function App() {
  return (
    <div>
      <BrowserRouter>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#3C1B24',
              colorError: '#C30010',
              borderRadius:3,
              borderRadius3: 3,
              borderrad2: 8,
              borderrad3: 5,
              borderCardrad:12,
              borderCardcolor: '#fff',
              cardshadow:'0px 4px 25px 0px #D9D9D9',
              mainColor: '#FE5112',
              secondarColor:'#001529',
              bgtransparent:'transparent',
              gradientToColor:'#F4F4F4'
            }
          }}
        >
          <Provider store={store}>
            <RouteF theme={theme.components} />
          </Provider>
        </ConfigProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
